import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "antd";
import { Hooks } from "@xt/xtbase";
import { post_user_coupon_cash_redeem } from "@/api/coupon-user";
import { normalizeUserCoupon } from "../normalizeUserCoupon";
import { translateVoucherApiMc } from "../translateVoucherApiMc";
import styles from "./index.module.less";

const { useTranslation } = Hooks;

export const VOUCHER_CASH_REDEEM_SUCCESS_EVENT = "voucher-cash-redeem-success";

/**
 * 真金券（CASH_CREDIT）兑现确认弹窗 — POST cash-redeem
 */
export default function VoucherCashRedeemModal({ open, coupon, onClose, onSuccess }) {
  const t = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const resetState = useCallback(() => {
    setSubmitting(false);
    setErrorMsg("");
  }, []);

  useEffect(() => {
    if (!open) {
      resetState();
    }
  }, [open, resetState]);

  const handleConfirm = async () => {
    if (!coupon?.id || submitting) return;
    setSubmitting(true);
    setErrorMsg("");
    try {
      const res = await post_user_coupon_cash_redeem(coupon.id, {});
      if (res && res.rc === 0) {
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent(VOUCHER_CASH_REDEEM_SUCCESS_EVENT));
        }
        onSuccess?.(normalizeUserCoupon(res.result) || coupon);
        onClose?.();
        return;
      }
      setErrorMsg(
        translateVoucherApiMc(t, res?.mc, "activity.voucherCashRedeemFailed") ||
          t("activity.voucherCashRedeemFailed")
      );
    } catch (e) {
      console.error("[voucher] cash-redeem", e);
      setErrorMsg(
        translateVoucherApiMc(t, e?.mc, "activity.voucherCashRedeemFailed") ||
          t("activity.voucherCashRedeemFailed")
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (submitting) return;
    onClose?.();
  };

  const amountText = [coupon?.amount, coupon?.unit].filter(Boolean).join(" ").trim() || "—";

  return (
    <Modal
      open={open && !!coupon}
      className={styles.cashRedeemModal}
      centered
      closable={false}
      maskClosable={!submitting}
      footer={null}
      width={311}
      destroyOnClose
      onCancel={handleClose}
    >
      <div className={styles.modalContent}>
        <div id="voucher-cash-redeem-title" className={styles.title}>
          {t("activity.voucherCashRedeemConfirmTitle")}
        </div>
        <div id="voucher-cash-redeem-desc" className={styles.content}>
          {t("activity.voucherCashRedeemConfirmDesc", {
            amount: amountText,
          })}
        </div>
        {errorMsg ? <p className={styles.errorMsg}>{errorMsg}</p> : null}
      </div>
      <div className={styles.modalFooter}>
        <button type="button" className={styles.cancelBtn} disabled={submitting} onClick={handleClose}>
          {t("activity.voucherCashRedeemCancel")}
        </button>
        <button type="button" className={styles.confirmBtn} disabled={submitting} onClick={handleConfirm}>
          {submitting ? t("activity.rewardClaimLoading") : t("activity.voucherCashRedeemConfirm")}
        </button>
      </div>
    </Modal>
  );
}
